/* Merchant-selected Bestseller Hats edit. Does not change catalog or pricing. */
(()=>{
 'use strict';
 if(!document.querySelector('#collection-page')||window.PS_BESTSELLERS)return;
 const ids=['112','256','6277','256p','112fpr','168','ofa','258','111','staged-110m-flexfit-mesh-back','172','8110','6606','112p','180'];
 const href='#collection?edit=bestsellers';
 const active=()=>location.hash.split('?')[0]==='#collection'&&new URLSearchParams(location.hash.split('?')[1]||'').get('edit')==='bestsellers';
 const originalRender=renderProducts,originalFilters=applyCatalogFilters;
 window.PS_BESTSELLERS={ids:[...ids],href};
 const nav=document.querySelector('.navigation > div');
 if(nav&&!nav.querySelector('[data-bestseller-link]')){
  const link=document.createElement('a');link.href=href;link.textContent='Bestseller Hats';link.dataset.bestsellerLink='';
  const shop=[...nav.querySelectorAll('a')].find(a=>a.textContent.trim()==='Shop Hats');
  if(shop)shop.after(link);else nav.append(link);
 }
 renderProducts=function(category='all',query=document.querySelector('#search').value||''){
  const link=document.querySelector('[data-bestseller-link]');
  if(link){if(active())link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');}
  if(!active())return originalRender(category,query);
  const engine=window.PS_FILTER_ENGINE,state=catalogFilterState({query});
  const ranks=new Map(ids.map((id,index)=>[id,index]));
  const shown=products.filter(p=>engine.matches(p,state)&&engine.categoryMatches(p,category));
  if(document.querySelector('#sort').value==='name')shown.sort((a,b)=>a.name.localeCompare(b.name));
  else shown.sort((a,b)=>(ranks.get(a.id)??ids.length)-(ranks.get(b.id)??ids.length));
  document.querySelector('#collection-heading').textContent='Bestseller Hats';
  document.querySelector('#collection-crumb').textContent='Home / Bestseller Hats';
  const total=products.filter(p=>engine.isListing(p)&&p.productKind==='headwear').length;
  document.querySelector('#collection-intro').textContent='Our 15 bestsellers come first. Explore all '+total+' hat styles below, or find your fit with our full-catalog filters.';
  const host=document.querySelector('#catalog-products'),more=document.querySelector('#catalog-more');let displayed=0;
  host.replaceChildren();
  function page(){
   const next=shown.slice(displayed,displayed+36);
   host.insertAdjacentHTML('beforeend',next.map(productCard).join(''));displayed+=next.length;
   more.hidden=displayed>=shown.length;more.textContent='Show More Headwear ('+(shown.length-displayed)+' remaining)';decorate();
  }
  more.onclick=page;page();
  if(!shown.length)host.innerHTML='<div class="brand-empty"><h3>No matching hats.</h3><p>Try another filter to explore our hats.</p><button class="button orange" data-reset-filters>Clear All Filters</button></div>';
  document.querySelector('#result-count').textContent=shown.length+' headwear '+(shown.length===1?'style':'styles')+' · Bestsellers first';
  updateCatalogFacets(state);
  decorate();
 };
 applyCatalogFilters=function(overrides={}){
  if(!active())return originalFilters(overrides);
  const state=catalogFilterState(overrides),params=new URLSearchParams({edit:'bestsellers'});
  for(const key of ['brand','style','feature','fit','profile'])if(state[key]&&state[key]!=='all')params.set(key,state[key]);
  if(state.query.trim())params.set('q',state.query.trim());
  const hash='#collection?'+params.toString();
  if(location.hash===hash)route();else location.hash=hash;
 };
 // Deferred asset runs after the existing router's initial render.
 if(active())renderProducts();
})();